import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { FDBox, FDPaper, FDStack } from '@facet-wealth/design';
import React from 'react';
import { TitleTextLarge } from 'Packages/FacetDesign/Components';
import useManualRolloverContext from 'Views/Page/Content/Templates/ManualRolloverTemplate/ManualRolloverContext';
import fr from 'facet-rest';
import { AttachmentsList } from 'Organisms/AttachmentsList/AttachmentsList';
import FileUploadDropAreaWithAttachmentList
  from 'Components/ComponentLibrary/Molecules/FileUploadDropAreaWithAttachmentList';

const MainContent = () => {
  const { resource } = useMetaLayoutContext();
  const {
    attachments, refreshResource,
  } = useManualRolloverContext(resource);

  return (
    <FDStack direction={'column'} alignItems={'center'} justifyContent={'center'}>
      <FDPaper appearance="elevated" padding={3}>
        <FDStack direction={'column'} justifyContent={'center'} spacing={3}>
          <TitleTextLarge value={resource.attr('mainContentHeader')} align={'center'} />
          {resource.withRelationship(
            fr.relationships.uploadFile.name,
            (rel) => (
              <FileUploadDropAreaWithAttachmentList
                trailingTitleText={'account statement'}
                subtitle={'JPG, PNG, PDF with max file size 50MB'}
                url={rel.link('related').url()}
                onSuccess={refreshResource}
                onError={refreshResource}
                acceptedFileTypes={['image/*', '.pdf']}
                attachments={attachments}
                onDelete={refreshResource}
                confirmOnDelete
              />
            ), () => (
              <FDBox width={'100%'} alignSelf={'center'}>
                <AttachmentsList
                  attachments={attachments}
                  onDelete={refreshResource}
                  confirmOnDelete
                />
              </FDBox>
            ),
          )}
        </FDStack>
      </FDPaper>
    </FDStack>
  );
};

MainContent.defaultProps = {
};

MainContent.propTypes = {
};

export default MainContent;
